import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-black text-white py-12 sm:py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-8 sm:mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4 sm:mb-6">
              <div className="w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/4f1631beadcf28a46c927c9761f1e912.png" 
                  alt="NPA Logo" 
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <p className="text-yellow-400 text-lg sm:text-xl font-semibold">Premium Car Rental</p>
              </div>
            </div>
            
            <p className="text-yellow-400 text-base sm:text-lg font-semibold mb-3 sm:mb-4">
              {t('footer.tagline')}
            </p>
            
            <p className="text-gray-300 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
              {t('footer.description')}
            </p>

            <div className="flex space-x-3 sm:space-x-4">
              <a href="#" className="w-8 h-8 sm:w-10 sm:h-10 bg-yellow-400 rounded-full flex items-center justify-center text-black hover:bg-yellow-300 transition-colors">
                <i className="ri-facebook-fill text-sm sm:text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 sm:w-10 sm:h-10 bg-yellow-400 rounded-full flex items-center justify-center text-black hover:bg-yellow-300 transition-colors">
                <i className="ri-instagram-line text-sm sm:text-base"></i>
              </a>
              <a href="#" className="w-8 h-8 sm:w-10 sm:h-10 bg-yellow-400 rounded-full flex items-center justify-center text-black hover:bg-yellow-300 transition-colors">
                <i className="ri-twitter-line text-sm sm:text-base"></i>
              </a>
              <a href="https://wa.me/237693695377" target="_blank" rel="noopener noreferrer" className="w-8 h-8 sm:w-10 sm:h-10 bg-green-600 rounded-full flex items-center justify-center text-white hover:bg-green-500 transition-colors">
                <i className="ri-whatsapp-line text-sm sm:text-base"></i>
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6">{t('footer.contact')}</h4>
            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-start space-x-2 sm:space-x-3">
                <i className="ri-map-pin-line text-yellow-400 mt-1 text-sm sm:text-base"></i>
                <p className="text-gray-300 text-sm sm:text-base">Rhône-Poulenc - En face de l'église évangélique<br />Douala, Cameroun</p>
              </div>
              
              <div className="flex items-start space-x-2 sm:space-x-3">
                <i className="ri-phone-line text-yellow-400 mt-1 text-sm sm:text-base"></i>
                <div className="text-gray-300 text-sm sm:text-base">
                  <p>+237 693 695 377</p>
                  <p>+237 695 047 961</p>
                  <p>+237 671 954 603</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-2 sm:space-x-3">
                <i className="ri-time-line text-yellow-400 text-sm sm:text-base"></i>
                <p className="text-gray-300 text-sm sm:text-base">24h/7j</p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg sm:text-xl font-bold mb-4 sm:mb-6">Liens Rapides</h4>
            <div className="space-y-2 sm:space-y-3">
              <a href="#home" className="block text-gray-300 hover:text-yellow-400 transition-colors text-sm sm:text-base">Accueil</a>
              <a href="#fleet" className="block text-gray-300 hover:text-yellow-400 transition-colors text-sm sm:text-base">Notre Flotte</a>
              <a href="#services" className="block text-gray-300 hover:text-yellow-400 transition-colors text-sm sm:text-base">Services</a>
              <a href="#about" className="block text-gray-300 hover:text-yellow-400 transition-colors text-sm sm:text-base">À Propos</a>
              <a href="#contact" className="block text-gray-300 hover:text-yellow-400 transition-colors text-sm sm:text-base">Contact</a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
            <p className="text-gray-400 text-xs sm:text-sm text-center sm:text-left">
              © 2024 NPA Premium Car Rental. {t('footer.rights')}
            </p>
            <span className="text-gray-400 text-xs sm:text-sm">
              WOW (WhatsApp Order Website) powered by Wazi Consulting
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
